"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var object_1 = require("./object");

var ChartElementClass =
/*#__PURE__*/
function (_object_1$ObjectClass) {
  _inherits(ChartElementClass, _object_1$ObjectClass);

  function ChartElementClass() {
    _classCallCheck(this, ChartElementClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChartElementClass).apply(this, arguments));
  }

  _createClass(ChartElementClass, [{
    key: "buildConstraints",

    /** Get intrinsic constraints between attributes (e.g., x2 - x1 = width for rectangles) */
    value: function buildConstraints(solver, context) {}
    /** Get the graphics that represent this layout */

  }, {
    key: "getGraphics",
    value: function getGraphics(manager) {
      return null;
    }
    /** Get handles given current state */

  }, {
    key: "getHandles",
    value: function getHandles() {
      return [];
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      return null;
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      return [];
    }
  }, {
    key: "getDropZones",
    value: function getDropZones() {
      return [];
    }
    /** Get controls given current state */

  }, {
    key: "getPopupEditor",
    value: function getPopupEditor(manager) {
      return null;
    }
  }], [{
    key: "createDefault",
    value: function createDefault() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var element = (_get2 = _get(_getPrototypeOf(ChartElementClass), "createDefault", this)).call.apply(_get2, [this].concat(args));

      return element;
    }
  }]);

  return ChartElementClass;
}(object_1.ObjectClass);

exports.ChartElementClass = ChartElementClass;